import React from 'react'
import '../styles/Footer.css'

function Footer() {
  return (
    <div className='footer-container'>
      <span>developed by Sejo Bašić</span>
      <span>2026</span>
    </div>
  )
}

export default Footer
